export default {
  title: 'Tasks',

  schedule: {
    now: 'Start now',
    delay: 'Schedule for ',
    delayed: 'Schedule for '
  },

  labels: {
    id: 'ID',
    title: 'Title',
    cycle: {
      batch: 'Numbers of messages',
      every: 'Every (seconds)'
    },
    owner: 'Owner',
    creator: 'Создатель',
    type: 'Type',
    state: 'State',
    data: {
      source: 'Source',
      amount: 'Amount',
      frequency: 'Frequency',
      endsAt: 'Ends at'
    },
    startsAt: 'Starts at',
    analytics: 'Analytics',
    contactLists: 'Contact lists'
  },

  headers: {
    title: 'Title',
    task: 'Task',
    progress: 'Progress',
    type: 'Type',
    state: 'State',
    sent: 'Sent',
    statistic: 'Statistic',
    errored: 'Errored',
    text: 'Text',
    owner: 'Owner',
    actions: 'Actions'
  },

  dialogs: {
    create: 'Create new task'
  },

  states: {
    scheduled: 'Scheduled',
    running: 'Running',
    paused: 'Paused',
    completed: 'Completed',
    failed: 'Failed',
    stopped: 'Stopped'
  },

  simpleStates: {
    scheduled: 'Active',
    running: 'Active',
    paused: 'Paused',
    completed: 'Done',
    failed: 'Failed'
  },

  actions: {
    resume: 'Resume',
    start: 'Start',
    schedule: 'Schedule',
    paused: 'Pause'
  },

  misc: {
    receivers: 'Total recipients',
    sent: 'Sent',
    errored: 'Errored',
    rest: 'Remaining',
    include: {
      lists: 'Lists include',
      recipients: 'Recipients include'
    },
    exclude: {
      lists: 'Lists exclude',
      recipients: 'Recipients exclude'
    },
    total: 'Total'
  },

  titles: {
    analytics: 'Tasks analytics',
    filter: 'Tasks filter',

    states: {
      stopped: 'Stop task'
    }
  },

  types: {
    bulk: 'Dispatch',
    'sendings:bulk': 'Sendings bulk',
    'payments:recurrent': 'Recurrent Payment',
    'billings:operations': 'Financial Operation'
  },

  subheaders: {
    include: {
      lists: 'Lists include',
      recipients: 'Recipients include'
    },
    exclude: {
      lists: 'Lists exclude',
      recipients: 'Recipients exclude'
    },
    error: {
      lists: 'With error'
    },
    errors: 'Errors'
  },

  contents: {
    confirm: {
      remove: 'Are you sure you want to delete the task {title}?',

      states: {
        stopped: `
You are about to perform an irreversible action.<br>
After stopping the task, it will not be possible to resume it.<br><br>
If you want to pause the task and resume it later, use the pause button.<br><br>
<strong class="mt-2">Are you sure you want to continue?<strong>
`
      }
    }
  },

  buttons: {
    today: 'Todays',
    twoWeeks: 'Scheduled',
    analytics: 'Analytics',
    refresh: 'Refresh'
  },

  confirm: {
    remove: {
      title: 'Confirm remove task',
      text: 'You`re about to delete a task {title}.'
    }
  },

  frequencies: {
    once: 'Once',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',

    title: {
      once: 'Once',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly'
    }
  },

  tooltips: {
    refresh: 'Refresh table data with selected filter.',

    states: {
      paused: 'Pause task',
      stopped: 'Stop task',
      scheduled: 'Schedule task'
    }
  },

  snackbars: {
    updated: 'Task success updated',
    removed: 'Task success removed',
    created: 'Task success created'
  }
}
